import httpClient from "@/plugins/axios";

export const getDefaultNewsImage = async () => {
    const response = await httpClient.get(`/admin/v1/tenant/news-image/`);
    return response;
}


export const saveDefaultNewsImage = async (image, imageName) => {
    var formData = new FormData();
    formData.append('news_image', image, imageName);

    const response = await httpClient.put(`/admin/v1/tenant/news-image/`, formData);
    return response;
}

export const deleteDefaultNewsImage = async () => {
    const response = await httpClient.delete(`/admin/v1/tenant/news-image/`);
    return response;
}
